import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Inputs } from '../../../components';
import { useTranslation } from 'react-i18next';
import { actionPatient } from '../../../redux/actions';

const DigestionAndNutrition = ({ loginData, activeTab, tabId }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const getQuestionData3 = useSelector((state) => state.patient.getQuestionData3?.data?.result || []);
    const getAnswersData3 = useSelector((state) => state.patient.getAnswersData3?.data?.result || []);

    const [answersData, setAnswersData] = useState([]);

    const handleAnswerChange = (questionGuid, ans) => {
        setAnswersData((prevAnswers) =>
            prevAnswers.map((item) =>
                item.questionGuid === questionGuid
                    ? {
                        ...item,
                        answer1: ans,
                        answer2: ans === "NA" ? null : ans === "No" ? "" : item.answer2,
                    }
                    : item
            )
        );
    };



    useEffect(() => {
        // Only update answersData if different from current local state
        // Simple deep compare with JSON.stringify (good for small arrays)
        if (JSON.stringify(answersData) !== JSON.stringify(getAnswersData3)) {
            setAnswersData(getAnswersData3);
        }
    }, [answersData, getAnswersData3]);

    useEffect(() => {
        if (
            activeTab === tabId &&
            loginData?.userGuid &&
            loginData?.languageAbb
        ) {
            dispatch(actionPatient.getQuestion3(loginData.languageAbb));
            dispatch(actionPatient.getAnswers3(loginData.userGuid));
        }
    }, [activeTab, tabId, loginData?.languageAbb, loginData?.userGuid, dispatch]);
    return (
        <div>
            {getQuestionData3.map((que, index) => {
                const matchedAnswer = answersData.find(
                    (ans) => ans.questionGuid === que.questionGuid
                );
                const selectedValue = matchedAnswer?.answer1;

                return (
                    <div key={index} className="health-info-que-ans-tab-blk">
                        <p className="exado-title-seven health-info-que">
                            {que.question}
                        </p>

                        {que.questionType === 1 && (
                            <div className="health-info-ans-radio-blk">
                                <Inputs.CheckRadioInput
                                    type="radio"
                                    label={t("yes")}
                                    name={`answer-${que.questionGuid}`}
                                    className="form-grp-radio"
                                    checked={selectedValue === "Yes"}
                                    onChange={() => handleAnswerChange(que.questionGuid, "Yes")}
                                />
                                <Inputs.CheckRadioInput
                                    type="radio"
                                    label={t("no")}
                                    name={`answer-${que.questionGuid}`}
                                    className="form-grp-radio"
                                    checked={selectedValue === "No"}
                                    onChange={() => handleAnswerChange(que.questionGuid, "No")}
                                />
                                <Inputs.CheckRadioInput
                                    type="radio"
                                    label={t("dont_know")}
                                    name={`answer-${que.questionGuid}`}
                                    className="form-grp-radio"
                                    checked={selectedValue === "NA"}
                                    onChange={() => handleAnswerChange(que.questionGuid, "NA")}
                                />
                            </div>
                        )}

                        {que.questionType === 4 && (
                            <div className="health-info-ans-radio-blk">
                                {que.multipleOptions
                                    .split(",")
                                    .map((option, optIndex) => (
                                        <Inputs.CheckRadioInput
                                            key={optIndex}
                                            type="radio"
                                            label={option}
                                            name={`answer-${que.questionGuid}`}
                                            className="form-grp-radio"
                                            checked={selectedValue === option}
                                            onChange={() => handleAnswerChange(que.questionGuid, option)}
                                        />
                                    ))}
                            </div>
                        )}

                        {selectedValue === "Yes" && (
                            <Inputs.FormInputs
                                type="textarea"
                                label={t("patient_Details.health_information.additional_info")}
                                value={matchedAnswer?.answer2 || ""}
                                readOnly={true}
                                grpClassname="form-group"
                            />
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default DigestionAndNutrition;
